import React, { useEffect, useState } from 'react';
import { Box, DataGrid, DateBox, DropDownBox, SelectBox } from "devextreme-react";
import { dataSourceSelect } from '../../services/store';
import uri from '../../utils/uri';
import Bills from '../../views/bills/Bills';
import BillCxC from './BillCxC';
import http from '../../utils/http';

const BillByClient = props => {

    
    const { open, id } = props;

    const [clientId, setClientId] = useState(0);

    const onValueChanged = (e) => {
            setClientId(e.value);
    }

    useEffect(() => {
        http(uri.receivables.getById(id)).asGet().then(resp => {

            if(resp)
                setClientId(resp.bill.clientId);    

        })
    }, [open]);

    return (
        <div>
            <div className="ml-10">
                <label>Seleccione el cliente:</label>
                <SelectBox 
                    value={clientId}
                    defaultValue={clientId}
                    searchEnabled={true}
                    placeholder="Selecciona un cliente"
                    showClearButton={true} valueExpr="id" displayExpr="fullName" 
                    onValueChanged={onValueChanged}     
                    dataSource={dataSourceSelect(uri.clients.asCatalog, uri.clients.getById(clientId))}
                />
                <BillCxC clientId={clientId}/>
            </div>
        </div>
    );
}

export default BillByClient;
